import { createStyles, Stack, Text } from '@mantine/core';
import React from 'react';

interface StatsWidgetProps {
  label: string;
  count: number | undefined;
}

export function StatsWidget({ label, count }: StatsWidgetProps) {
  const { classes } = useStyles();

  return (
    <Stack className={classes.widgetContainer} spacing="xs">
      <Text color="gray.6" size="md">
        {label}
      </Text>
      <Text color="gray.8" size={28}>
        {count || 0}
      </Text>
    </Stack>
  );
}

const useStyles = createStyles((theme) => ({
  widgetContainer: {
    borderRadius: theme.radius.lg,
    backgroundColor: theme.white,
    padding: theme.spacing.xxl,
    minWidth: 300,
  },
}));
